import type { RouteRecordRaw } from 'vue-router';

import { OrganizationModule } from '@/entities/auth';

const AutomationPage = () => import('@/pages/automation').then((m) => ({ default: m.AutomationPage }));
const ScenariosPage = () => import('@/pages/scenarios').then((m) => ({ default: m.ScenariosPage }));
const ScenarioEditPage = () => import('@/pages/scenario/ui/ScenarioEditPage.vue');
const ScenarioViewPage = () => import('@/pages/scenario/ui/ScenarioViewPage.vue');
const MarketingSourcesPage = () =>
  import('@/pages/marketing-sources').then((m) => ({ default: m.MarketingSourcesPage }));
const MarketingSourcePage = () => import('@/pages/marketing-source').then((m) => ({ default: m.MarketingSourcePage }));
const BroadcastsPage = () => import('@/pages/broadcasts').then((m) => ({ default: m.BroadcastsPage }));
const BroadcastPage = () => import('@/pages/broadcast').then((m) => ({ default: m.BroadcastPage }));
const QrLinksPage = () => import('@/pages/qr-links').then((m) => ({ default: m.QrLinksPage }));
const QrLinkEditPage = () => import('@/pages/qr-link').then((m) => ({ default: m.QrLinkEditPage }));

// Модуль не указан намеренно: клиентские автоматизации уходят у всех организаций,
// доступ определяет право (см. серверный гейт без @module).
const automationRouteMeta = {
  requiresAuth: true,
  requiresOrganization: true,
  title: 'Автоматизация',
  permissions: ['client_automations.manage'],
};
export const marketingRoutes: RouteRecordRaw[] = [
  // Client automations
  {
    path: '/automation',
    name: 'automation.index',
    component: AutomationPage,
    meta: { sidebar: true, ...automationRouteMeta },
  },
  {
    path: '/automation/:kind/new',
    name: 'automation.create',
    component: AutomationPage,
    meta: { ...automationRouteMeta, title: 'Новая автоматизация' },
  },
  // Встроенная карточка вида — без id, созданная — со своим id.
  {
    path: '/automation/:kind/:id?',
    name: 'automation.edit',
    component: AutomationPage,
    meta: { ...automationRouteMeta, title: 'Настройка автоматизации' },
  },

  // Scenarios
  {
    path: '/scenarios',
    name: 'scenarios.index',
    component: ScenariosPage,
    meta: {
      sidebar: true,
      requiresAuth: true,
      requiresOrganization: true,
      title: 'Сценарии',
      modules: [OrganizationModule.Marketing],
      permissions: ['scenario.view'],
    },
  },
  {
    path: '/scenarios/new',
    name: 'scenarios.create',
    component: ScenarioEditPage,
    meta: {
      requiresAuth: true,
      requiresOrganization: true,
      title: 'Новый сценарий',
      modules: [OrganizationModule.Marketing],
      permissions: ['scenario.create'],
    },
  },
  {
    path: '/scenarios/:id',
    name: 'scenarios.show',
    component: ScenarioViewPage,
    meta: {
      requiresAuth: true,
      requiresOrganization: true,
      title: 'Сценарий',
      modules: [OrganizationModule.Marketing],
      permissions: ['scenario.view'],
    },
  },
  {
    path: '/scenarios/:id/edit',
    name: 'scenarios.edit',
    component: ScenarioEditPage,
    meta: {
      requiresAuth: true,
      requiresOrganization: true,
      title: 'Редактирование сценария',
      modules: [OrganizationModule.Marketing],
      permissions: ['scenario.update'],
    },
  },

  // Marketing sources
  {
    path: '/marketing-sources',
    name: 'marketing-sources.index',
    component: MarketingSourcesPage,
    meta: {
      sidebar: true,
      requiresAuth: true,
      requiresOrganization: true,
      title: 'Каналы привлечения',
      modules: [OrganizationModule.Marketing],
      permissions: ['marketing_source.view'],
    },
  },
  {
    path: '/marketing-sources/new',
    name: 'marketing-sources.create',
    component: MarketingSourcePage,
    meta: {
      requiresAuth: true,
      requiresOrganization: true,
      title: 'Новый канал',
      modules: [OrganizationModule.Marketing],
      permissions: ['marketing_source.create'],
    },
  },
  {
    path: '/marketing-sources/:id',
    name: 'marketing-sources.edit',
    component: MarketingSourcePage,
    meta: {
      requiresAuth: true,
      requiresOrganization: true,
      title: 'Редактирование канала',
      modules: [OrganizationModule.Marketing],
      permissions: ['marketing_source.update'],
    },
  },

  // QR Links
  {
    path: '/marketing/broadcasts',
    name: 'broadcasts.index',
    component: BroadcastsPage,
    meta: {
      requiresAuth: true,
      requiresOrganization: true,
      title: 'Рассылки',
      modules: [OrganizationModule.Marketing],
      permissions: ['marketing.broadcasts.view'],
    },
  },
  {
    path: '/marketing/broadcasts/new',
    name: 'broadcasts.create',
    component: BroadcastPage,
    meta: {
      requiresAuth: true,
      requiresOrganization: true,
      title: 'Новая рассылка',
      modules: [OrganizationModule.Marketing],
      permissions: ['marketing.broadcasts.manage'],
    },
  },
  {
    path: '/marketing/broadcasts/:id',
    name: 'broadcasts.show',
    component: BroadcastPage,
    meta: {
      requiresAuth: true,
      requiresOrganization: true,
      title: 'Рассылка',
      modules: [OrganizationModule.Marketing],
      permissions: ['marketing.broadcasts.view'],
    },
  },
  {
    path: '/marketing/qr-links',
    name: 'qr-links.index',
    component: QrLinksPage,
    meta: {
      sidebar: true,
      requiresAuth: true,
      requiresOrganization: true,
      title: 'QR-коды',
      modules: [OrganizationModule.Marketing],
      permissions: ['qr_link.view'],
    },
  },
  {
    path: '/marketing/qr-links/new',
    name: 'qr-links.create',
    component: QrLinkEditPage,
    meta: {
      requiresAuth: true,
      requiresOrganization: true,
      title: 'Новый QR-код',
      modules: [OrganizationModule.Marketing],
      permissions: ['qr_link.create'],
    },
  },
  {
    path: '/marketing/qr-links/:id',
    name: 'qr-links.edit',
    component: QrLinkEditPage,
    meta: {
      requiresAuth: true,
      requiresOrganization: true,
      title: 'Редактирование QR-кода',
      modules: [OrganizationModule.Marketing],
      permissions: ['qr_link.view'],
    },
  },
];
